export default "__VITE_ASSET__DOQ8c2U7__"